
<template>

	<div cols="3" class="element-with-source">

		<b-form-input v-if="data != null && (!disabled || data.source)" size="sm" placeholder="Источник информации"
			:value="data.source"
			v-on:change="value => $emit('set_source', value)"
			:readonly="disabled"
		/>

		<div v-if="!disabled" class="element-with-source_btn">

			<base-icon :id="id" name="info"/>

		</div>

		<div v-if="!disabled" class="element-with-source_btn">
			
			<base-icon :id="id" name="upload" v-on:click="() => $refs.file.$el.click()" v-b-tooltip:fullscreen.hover.bottomright="'Загрузить файл'" />

		</div>

		<div v-if="data != null && data.file != null" class="element-with-source_btn">
			
			<base-icon :id="id" name="download" v-on:click="download" v-b-tooltip:fullscreen.hover.bottomright="'Скачать файл'" />

		</div>

		<b-form-file v-if="!disabled" ref="file" no-drop v-on:input="upload" style="display: none;" plain />

		<b-tooltip v-if="!disabled" :target="id" triggers="hover" container="fullscreen">

			<span>Для подтверждения данных необходимо приложить файл</span>

		</b-tooltip>

	</div>

</template>

<script>

import { uuid } from "vue-uuid"
import api from "../../api"

export default
{
	props :
	{
		data : Object,
		disabled :  { type : Boolean, default : () => false }
	},

	beforeMount()
	{
		this.id = uuid.v1()
	},

	data()
	{
		return {

			id : null,

		}
	},

	methods :
	{
		download()
		{
			const url = api.file_url(this.data.file.url)

			api.download_file({ url : url })
			// window.open(api.file_url(this.data.file.url), "_blank")
		},

		upload(fl)
		{
			const reader = new FileReader()
			var _fl = fl

			reader.onload =
				fl =>
					api.upload_file(this, fl, _fl.name, _fl.name, response => this.$emit("set_file", response.id))
			
			reader.readAsBinaryString(_fl)
		},
	}
}

</script>

<style>
.element-with-source
{
	display: flex;
	gap: 4px;
	align-items: center;
	height: min-content;
}

.element-with-source_btn
{
	color: var(--bft-neutral-400);
	width: 24px;
	height: 24px;
}
</style>
